// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .prediction-basic-from .form-column[data-v-270d9fbe] {\n  width: auto;\n}\n.required .el-form-item__label[data-v-270d9fbe] {\n  color: #1F75D5 !important;\n}\n.poNoClass[data-v-270d9fbe] .el-input.is-disabled .el-input__inner {\n  color: red !important;\n}\n", ""]);
// Exports
module.exports = exports;
